import { Dropdown } from "bootstrap";

document.addEventListener('DOMContentLoaded', function() {
    const $backToTopBtn = $('.back-to-top');
    const $userHintBtn = $('.user-hint');
    const $mainContent = $('#main-content');
    const $bodyEl = $('body');
    const scrollThreshold = 300;

    // Show/Hide Button on Scroll
    $(window).on('scroll', function() {
        if ($(this).scrollTop() > scrollThreshold) {
            $backToTopBtn.addClass('is-visible');
            $userHintBtn.removeClass('is-solo');
        } else {
            $backToTopBtn.removeClass('is-visible');
            $userHintBtn.addClass('is-solo');
        }
    });

    function restoreFocusAfterScroll() {
        if ($mainContent.length) {
            $mainContent.attr('tabindex', '-1').focus();
            $mainContent.removeAttr('tabindex');
        } else {
            $bodyEl.attr('tabindex', '-1').focus();
            $bodyEl.removeAttr('tabindex');
        }
    }

    $backToTopBtn.on('click', function(e) {
        e.preventDefault();

        // Use native smooth scroll if supported
        if ('scrollBehavior' in document.documentElement.style) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            restoreFocusAfterScroll();
        } else {
            // Fallback to jQuery animation for older browsers
            $('html, body').animate({
                scrollTop: 0
            }, 800, restoreFocusAfterScroll);
        }
    });

    // to ensure the button visibility is correct if the page loads scrolled down.
    $(window).trigger('scroll');

    // on hover we are using css to show menu, we are just making sure aria is correct
    const $dropdownNavItems = $('.navbar-nav .dropdown');
    
    $dropdownNavItems.each((index, dropdownItem) => {
        const $dropdownToggle = $(dropdownItem).find('.dropdown-toggle').first();

        if (!$dropdownToggle.length) return;

        $(dropdownItem).on("mouseenter", () => {
            $dropdownToggle.attr('aria-expanded', 'true');
        }).on("mouseleave", () => {
            $dropdownToggle.attr('aria-expanded', 'false');
        });
    });

    /* ---------------------------------------------------
    // hide header on scroll down, but show on scroll up
    --------------------------------------------------- */
    const doc = document.documentElement;
    const header = document.querySelector('.js-site-header');
    let lastScroll = 0;

// Function to update the CSS Variable height
    const updateHeaderHeight = () => {
        if (header) {
            const height = header.offsetHeight;
            doc.style.setProperty('--header-height', `${height}px`);

            // If header is visible, ensure variables match 'Up' state
            if (!header.classList.contains('header--hidden')) {
                $('body').addClass('at-top');
            }
        }
    };

// 2. Scroll Direction Logic
    const handleScroll = () => {
        const currentScroll = window.pageYOffset;
        const headerHeight = header?.offsetHeight || 0;

        if (currentScroll <= 0) { // AT TOP
            $('body').removeClass('scrolling-down scrolling-up');
            $('body').addClass('at-top');
            header.classList.remove('header--hidden');
            lastScroll = 0;
            return;
        }

        if (Math.abs(currentScroll - lastScroll) < 10) return;

        if (currentScroll > lastScroll && currentScroll > headerHeight) { // scrolling down
            $('body').removeClass('at-top scrolling-up');
            $('body').addClass('scrolling-down');
            header.classList.add('header--hidden');
        } else { // Scrolling Up
            $('body').removeClass('at-top scrolling-down');
            $('body').addClass('scrolling-up');
            header.classList.remove('header--hidden');
        }
        lastScroll = currentScroll;
    };

// Listeners
    window.addEventListener('resize', updateHeaderHeight);
    window.addEventListener('scroll', handleScroll);
// Initial check
    updateHeaderHeight();

});
